import React from 'react';
import team1 from '../assets/img/team1.png'
import team2 from '../assets/img/team2.png'

// import about data
import { aboutData } from '../data';

const Team1 = () => {
  // destructure about
  const { image, title, subtitle } = aboutData;
  return (
    <section
      className='my-[30px] pt-[50px] xl:mt-[100px]'
      data-aos='fade-up'
      data-aos-offset='350'
    >
      <div className='container mx-auto'>
        <div className='bg-accent-about rounded-[50px] min-h-[700px] px-12 pb-12 pt-12 flex-col text-center xl:flex-row xl:items-center xl:text-left  xl:gap-x-[60px] xl:pb-0'>
        <div className='text-center'>
          <h2
            className='h2 mb-6 xl:mb-12'
            data-aos='fade-down'
            data-aos-delay='100'
          >
            Meet Our Team
          </h2>
          </div>
          {/* image */}
          <div className="flex-1 items-center">
                <div className='flex flex-row items-center'>
                <div className="flex justify-center mx-auto">
                  <div className="rounded-lg mr-20 shadow-lg bg-white max-w-xs">
                    <a href="https://faisalongit.github.io/react-portfolio/">
                      <img className="rounded-t-lg" src={team1} alt=""/>
                      </a>
                      <div className="p-6">
                        <h5 className="text-gray-900 text-xl font-bold text-center mb-2 font-secondary text-secondary">Faisal Rahman</h5>
                        <a href='https://faisalongit.github.io/react-portfolio/' type="button" className="ml-20 bg-accent-primary text-white p-3 text-center hover:bg-accent-tertiary transition-all duration-500 rounded">Know More</a>
                      </div>
                    </div>
                    <div className="rounded-lg shadow-lg bg-white max-w-xs">
                    <a href="#!">
                      <img className="rounded-t-lg" src={team2} alt=""/>
                      </a>
                      <div className="p-6">
                        <h5 className="text-gray-900 text-xl font-bold text-center mb-2 font-secondary text-secondary">Aria Priawan Yahya</h5>
                        <a href='https://ariapriawannn.github.io/' type="button" className="ml-20 bg-accent-primary text-white p-3 text-center hover:bg-accent-tertiary transition-all duration-500 rounded">Know More</a>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team1;
